import { List, useBreakpointProp } from '@betty/moonlight';
import { memo, useCallback, useState } from 'react';
import ShopItem from '../ShopItem/ShopItem';
import ShopItemListHeader from '../ShopItemListHeader/ShopItemListHeader';
import { useShopItems, useShopRouteParams } from '../../hooks';
import { LayoutChangeEvent } from 'react-native';
import { useResponsiveGridItemWidth } from '@betty/toolkit/hooks';

function ShopItemList() {
  const { filterParam, sortParam } = useShopRouteParams();

  const shopItems = useShopItems({ filter: filterParam, sort: sortParam });

  const numberOfColumns = useBreakpointProp({
    mobile: 2,
    tablet: 3,
    desktop: 6,
  });

  const [listWidth, setListWidth] = useState(0);

  const onLayout = useCallback((event: LayoutChangeEvent) => {
    setListWidth(event.nativeEvent.layout.width);
  }, []);

  const itemWidth = useResponsiveGridItemWidth({
    listWidth,
    numberOfColumns,
    gridGap: 'space-400',
    gridOffsetX: 'space-400',
    isShopItem: true,
  });

  if (!shopItems) return null;

  return (
    <List
      onLayout={onLayout}
      data={shopItems}
      initialNumToRender={6}
      windowSize={3}
      renderItem={({ item }) => <ShopItem {...item} maxWidth={itemWidth} />}
      keyExtractor={(item) => `${item.id}`}
      key={numberOfColumns}
      numColumns={numberOfColumns}
      contentContainerStyle={{
        gap: 'space-600',
        paddingBottom: 'space-600',
        width: '100%',
        maxWidth: 'max-page-width',
        marginHorizontal: 'auto',
      }}
      columnWrapperStyle={{
        gap: 'space-400',
        paddingHorizontal: 'space-400',
        justifyContent: 'flex-start',
      }}
      ListHeaderComponent={ShopItemListHeader}
    />
  );
}

export default memo(ShopItemList);
